/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Platform {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description Exchange operator credentials for an RFC 6265bis platform session. Enforces password verification in production and restricts passwordless bypass strictly to non-production environments via PlatformAuthService.
   *
   * @tags Platform
   * @name PlatformAuthExchange
   * @summary Platform session token exchange
   * @request POST:/api/platform/auth/exchange
   */
  platformAuthExchange = (data, params = {}) =>
    this.http.request({
      path: `/api/platform/auth/exchange`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Return identity details of the authenticated platform operator.
   *
   * @tags Platform
   * @name GetPlatformMe
   * @summary Get current platform operator profile
   * @request GET:/api/platform/auth/me
   * @secure
   */
  getPlatformMe = (params = {}) =>
    this.http.request({
      path: `/api/platform/auth/me`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve platform-wide operational KPIs and system metrics.
   *
   * @tags Platform
   * @name GetPlatformMetrics
   * @summary Get platform-wide overview metrics
   * @request GET:/api/platform/overview/metrics
   * @secure
   */
  getPlatformMetrics = (params = {}) =>
    this.http.request({
      path: `/api/platform/overview/metrics`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve live infrastructure status from the local Docker daemon.
   *
   * @tags Platform
   * @name GetInfrastructureStatus
   * @summary Get infrastructure status (Docker containers)
   * @request GET:/api/platform/overview/infrastructure
   * @secure
   */
  getInfrastructureStatus = (params = {}) =>
    this.http.request({
      path: `/api/platform/overview/infrastructure`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List all tenant organizations with active filters, pagination, and user/property counts.
   *
   * @tags Platform
   * @name ListPlatformOrganizations
   * @summary List all organizations across the platform
   * @request GET:/api/platform/organizations
   * @secure
   */
  listPlatformOrganizations = (query, params = {}) =>
    this.http.request({
      path: `/api/platform/organizations`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new tenant organization from the platform administration console.
   *
   * @tags Platform
   * @name CreatePlatformOrganization
   * @summary Provision a new tenant organization
   * @request POST:/api/platform/organizations
   * @secure
   */
  createPlatformOrganization = (data, params = {}) =>
    this.http.request({
      path: `/api/platform/organizations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update organization lifecycle status (ACTIVE, SUSPENDED).
   *
   * @tags Platform
   * @name UpdatePlatformOrganizationStatus
   * @summary Update organization lifecycle status (e.g. ACTIVE, SUSPENDED)
   * @request PUT:/api/platform/organizations/{id}/status
   * @secure
   */
  updatePlatformOrganizationStatus = (id, data, params = {}) =>
    this.http.request({
      path: `/api/platform/organizations/${id}/status`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve comprehensive tenant profile, user count, and property count.
   *
   * @tags Platform
   * @name GetPlatformOrganizationData
   * @summary View organization profile and details
   * @request GET:/api/platform/organizations/{id}/data
   * @secure
   */
  getPlatformOrganizationData = (id, params = {}) =>
    this.http.request({
      path: `/api/platform/organizations/${id}/data`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve all users associated with the target organization for diagnostic impersonation.
   *
   * @tags Platform
   * @name GetPlatformOrganizationUsers
   * @summary List members/users of a specific tenant organization
   * @request GET:/api/platform/organizations/{id}/users
   * @secure
   */
  getPlatformOrganizationUsers = (id, query, params = {}) =>
    this.http.request({
      path: `/api/platform/organizations/${id}/users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve platform-wide publications intelligence dashboard. Aggregates active/draft publications, geographic distribution across countries and zones, syndication portal coverage, and cross-organization activity.
   *
   * @tags Platform
   * @name GetPublicationsDashboard
   * @summary Get cross-tenant publications aggregate dashboard
   * @request GET:/api/platform/publications/dashboard
   * @secure
   */
  getPublicationsDashboard = (params = {}) =>
    this.http.request({
      path: `/api/platform/publications/dashboard`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve immutable platform audit logs with operator, action, and target organization filters.
   *
   * @tags Platform
   * @name ListPlatformAuditLogs
   * @summary List platform audit logs with pagination and filters
   * @request GET:/api/platform/audit-logs
   * @secure
   */
  listPlatformAuditLogs = (query, params = {}) =>
    this.http.request({
      path: `/api/platform/audit-logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Issue a tamper-proof, short-lived (15 min) read-only impersonation token for diagnostics.
   *
   * @tags Platform
   * @name GenerateImpersonationToken
   * @summary Generate a 15-minute scoped diagnostic impersonation token
   * @request POST:/api/platform/impersonation/token
   * @secure
   */
  generateImpersonationToken = (data, params = {}) =>
    this.http.request({
      path: `/api/platform/impersonation/token`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Authenticate current password, validate complexity, and update password hash.
   *
   * @tags Platform
   * @name ChangeAdminPassword
   * @summary Change platform admin password
   * @request POST:/api/platform/security/password
   * @secure
   */
  changeAdminPassword = (data, params = {}) =>
    this.http.request({
      path: `/api/platform/security/password`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Return whether MFA is enabled, the active method, and remaining backup code count.
   *
   * @tags Platform
   * @name GetAdminMfaStatus
   * @summary Retrieve platform admin MFA enrollment status
   * @request GET:/api/platform/security/mfa/status
   * @secure
   */
  getAdminMfaStatus = (params = {}) =>
    this.http.request({
      path: `/api/platform/security/mfa/status`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Generate TOTP secret, provisioning URI, and single-use backup recovery codes.
   *
   * @tags Platform
   * @name SetupAdminTotp
   * @summary Initialize TOTP MFA enrollment
   * @request POST:/api/platform/security/mfa/totp/setup
   * @secure
   */
  setupAdminTotp = (params = {}) =>
    this.http.request({
      path: `/api/platform/security/mfa/totp/setup`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Verify 6-digit TOTP code and activate MFA on the current user.
   *
   * @tags Platform
   * @name ConfirmAdminTotp
   * @summary Confirm TOTP enrollment with verification code
   * @request POST:/api/platform/security/mfa/totp/confirm
   * @secure
   */
  confirmAdminTotp = (data, params = {}) =>
    this.http.request({
      path: `/api/platform/security/mfa/totp/confirm`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Verify operator password and disable MFA on the current user.
   *
   * @tags Platform
   * @name DisableAdminMfa
   * @summary Disable MFA with step-up password verification
   * @request POST:/api/platform/security/mfa/disable
   * @secure
   */
  disableAdminMfa = (data, params = {}) =>
    this.http.request({
      path: `/api/platform/security/mfa/disable`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve all platform-level support tickets across all organizations.
   *
   * @tags Platform
   * @name ListPlatformTickets
   * @summary List all platform support tickets across the platform
   * @request GET:/api/platform/support/tickets
   * @secure
   */
  listPlatformTickets = (query, params = {}) =>
    this.http.request({
      path: `/api/platform/support/tickets`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Compute platform-wide support KPIs (open, urgent, SLA breached, avg response time).
   *
   * @tags Platform
   * @name GetPlatformSupportMetrics
   * @summary Get platform support operational KPIs
   * @request GET:/api/platform/support/metrics
   * @secure
   */
  getPlatformSupportMetrics = (params = {}) =>
    this.http.request({
      path: `/api/platform/support/metrics`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get full platform ticket details including message history and internal notes.
   *
   * @tags Platform
   * @name GetPlatformTicket
   * @summary Get platform support ticket details including internal notes
   * @request GET:/api/platform/support/tickets/{ticket_id}
   * @secure
   */
  getPlatformTicket = (ticketId, params = {}) =>
    this.http.request({
      path: `/api/platform/support/tickets/${ticketId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update platform ticket status, priority, category, assignment, and resolution notes.
   *
   * @tags Platform
   * @name UpdatePlatformTicket
   * @summary Update platform ticket metadata and fields
   * @request PUT:/api/platform/support/tickets/{ticket_id}
   * @secure
   */
  updatePlatformTicket = (ticketId, data, params = {}) =>
    this.http.request({
      path: `/api/platform/support/tickets/${ticketId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Transition platform ticket status (e.g. resolve with resolution notes or pause SLA).
   *
   * @tags Platform
   * @name UpdatePlatformTicketStatus
   * @summary Transition platform ticket status
   * @request PATCH:/api/platform/support/tickets/{ticket_id}/status
   * @secure
   */
  updatePlatformTicketStatus = (ticketId, data, params = {}) =>
    this.http.request({
      path: `/api/platform/support/tickets/${ticketId}/status`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Assign or reassign a platform ticket to a platform operator.
   *
   * @tags Platform
   * @name AssignPlatformTicket
   * @summary Assign platform ticket to operator
   * @request PATCH:/api/platform/support/tickets/{ticket_id}/assign
   * @secure
   */
  assignPlatformTicket = (ticketId, data, params = {}) =>
    this.http.request({
      path: `/api/platform/support/tickets/${ticketId}/assign`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Post an outbound reply to the submitter or record an internal operator note.
   *
   * @tags Platform
   * @name AddPlatformTicketMessage
   * @summary Post operator reply or internal note to platform ticket
   * @request POST:/api/platform/support/tickets/{ticket_id}/messages
   * @secure
   */
  addPlatformTicketMessage = (ticketId, data, params = {}) =>
    this.http.request({
      path: `/api/platform/support/tickets/${ticketId}/messages`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List full message timeline including internal operator notes.
   *
   * @tags Platform
   * @name ListPlatformTicketMessages
   * @summary List all messages in platform ticket thread
   * @request GET:/api/platform/support/tickets/{ticket_id}/messages
   * @secure
   */
  listPlatformTicketMessages = (ticketId, params = {}) =>
    this.http.request({
      path: `/api/platform/support/tickets/${ticketId}/messages`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve Temporal connection status, cluster health, and execution metrics. Provides graceful fallback when Temporal cluster is disconnected or idle.
   *
   * @tags Platform
   * @name GetTemporalSummary
   * @summary Get Temporal cluster summary and schedule health
   * @request GET:/api/platform/temporal/summary
   * @secure
   */
  getTemporalSummary = (params = {}) =>
    this.http.request({
      path: `/api/platform/temporal/summary`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List recurring workflow schedules with cron expressions, next run times, and states.
   *
   * @tags Platform
   * @name GetTemporalSchedules
   * @summary List all recurring workflows and schedules
   * @request GET:/api/platform/temporal/schedules
   * @secure
   */
  getTemporalSchedules = (params = {}) =>
    this.http.request({
      path: `/api/platform/temporal/schedules`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Manually trigger an ad-hoc execution of the given scheduled workflow.
   *
   * @tags Platform
   * @name TriggerTemporalSchedule
   * @summary Manually trigger a scheduled workflow run
   * @request POST:/api/platform/temporal/schedules/{schedule_id}/trigger
   * @secure
   */
  triggerTemporalSchedule = (scheduleId, params = {}) =>
    this.http.request({
      path: `/api/platform/temporal/schedules/${scheduleId}/trigger`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Toggle the pause state of a recurring workflow schedule.
   *
   * @tags Platform
   * @name PauseTemporalSchedule
   * @summary Pause or resume a scheduled workflow
   * @request POST:/api/platform/temporal/schedules/{schedule_id}/pause
   * @secure
   */
  pauseTemporalSchedule = (scheduleId, params = {}) =>
    this.http.request({
      path: `/api/platform/temporal/schedules/${scheduleId}/pause`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve marketplace vendors directory with multi-tier verification filtering.
   *
   * @tags Platform
   * @name ListMarketplaceVendors
   * @summary List and filter marketplace vendors directory
   * @request GET:/api/platform/marketplace/vendors
   * @secure
   */
  listMarketplaceVendors = (query, params = {}) =>
    this.http.request({
      path: `/api/platform/marketplace/vendors`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Admin moderation action to promote, demote, or verify a vendor profile.
   *
   * @tags Platform
   * @name UpdateVendorVerification
   * @summary Update vendor verification tier and audit note
   * @request PATCH:/api/platform/marketplace/vendors/{vendor_id}/verification
   * @secure
   */
  updateVendorVerification = (vendorId, data, params = {}) =>
    this.http.request({
      path: `/api/platform/marketplace/vendors/${vendorId}/verification`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve listings across all tenant organizations with syndication coverage and moderation state.
   *
   * @tags Platform
   * @name ListMarketplaceProperties
   * @summary List properties marketplace directory and syndication health
   * @request GET:/api/platform/marketplace/properties
   * @secure
   */
  listMarketplaceProperties = (query, params = {}) =>
    this.http.request({
      path: `/api/platform/marketplace/properties`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Moderate listing publication status (e.g. FLAGGED, PUBLISHED, ARCHIVED).
   *
   * @tags Platform
   * @name UpdatePropertyStatus
   * @summary Update listing publication status (moderation)
   * @request PATCH:/api/platform/marketplace/properties/{listing_id}/status
   * @secure
   */
  updatePropertyStatus = (listingId, data, params = {}) =>
    this.http.request({
      path: `/api/platform/marketplace/properties/${listingId}/status`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Superadmin intervention overriding any approval workflow cross-tenant.
   *
   * @tags Platform
   * @name OverrideApprovalWorkflow
   * @summary Platform superadmin intervention override on an approval workflow
   * @request POST:/api/platform/approvals/{workflow_id}/override
   * @secure
   */
  overrideApprovalWorkflow = (workflowId, data, params = {}) =>
    this.http.request({
      path: `/api/platform/approvals/${workflowId}/override`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
